// A'gong Contact — Enquiry pills
document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('[data-agong-ce]')) return;

  // Scroll animations
  if (window.IntersectionObserver) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-agong-ce-anim]').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('[data-agong-ce-anim]').forEach(function (el) { el.classList.add('is-visible'); });
  }

  // Pills
  var pills = document.querySelectorAll('[data-agong-ce-pill]');
  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      pills.forEach(function (p) { p.classList.remove('agong-ce__pill--active'); });
      pill.classList.add('agong-ce__pill--active');

      var value = pill.getAttribute('data-agong-ce-pill');

      // Update form subject fields
      var subjectHidden = document.querySelector('[data-agong-cf-subject]');
      var subjectDisplay = document.querySelector('[data-agong-cf-subject-display]');
      if (subjectHidden) subjectHidden.value = value;
      if (subjectDisplay) subjectDisplay.value = value;

      // Scroll to form section
      var targetId = pill.getAttribute('data-agong-scroll-to');
      if (targetId) {
        var target = document.getElementById(targetId);
        if (target) {
          setTimeout(function () {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        }
      }
    });
  });
});